<template>
  <v-row class="fill-height" align="center" no-gutters>
    <v-col class="dark fill-height" cols="6">
      <order-carousel />
    </v-col>
    <v-col :style="{ position: 'relative' }" class="fill-height d-flex flex-wrap align-center" cols="6">
      <div :style="{ position: 'absolute', top: 0, width: '100%' }">
        <v-progress-linear height="8" :value="progress"/>
      </div>
      
      <v-card v-if="progress == 33" class="box-shadow pa-7 mx-auto" max-width="520" outlined>
        <v-card-title class="font-weight-bold pa-0">
          Create An Account
        </v-card-title>
        <signup-form order/>
      </v-card>

      <render-form v-if="progress == 66" />
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import RenderForm from './components/RenderForm'
import SignupForm from '../../components/SignupForm.vue'
import OrderCarousel from './components/OrderCarousel.vue'

export default {
  metaInfo: {
    title: 'Order'
  },

  /*------------------------------------------------------------------------------
   * DATA
   *----------------------------------------------------------------------------*/
  data() {
    return {
      progress: 33,
    }
  },

  /*------------------------------------------------------------------------------
   * COMPUTED
   *----------------------------------------------------------------------------*/
  computed: {
    ...mapState({
      user: state => state.user.user
    })
  },

  /*------------------------------------------------------------------------------
   * WATCH
   *----------------------------------------------------------------------------*/
  watch: {
    'user': {
      handler(value) {
        if (value) this.progress = 66
      },
      immediate: true
    }
  },

  /*------------------------------------------------------------------------------
   * COMPONENTS
   *----------------------------------------------------------------------------*/
  components: {
    SignupForm,
    RenderForm,
    OrderCarousel,
  },
}
</script>